import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISpecialDayList } from '../../../Pages/Pricing/IPricing';

export const SpecialDaySlicer = createSlice({
  name: 'SpecialDay',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISpecialDayList[]>,
  reducers: {
    getSpecialDay: (state, _) => {
      state.isLoading = true;
    },
    successGetSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetSpecialDay: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getSpecialDay, failureGetSpecialDay, successGetSpecialDay } =
  SpecialDaySlicer.actions;

export default SpecialDaySlicer.reducer;
